import { useState } from "react";
import { supabase } from "../../supabaseClient";
import "./AccountonHold.css";

export default function AccountOnHold() {
  const [requested, setRequested] = useState(false);
  const [loading, setLoading]     = useState(false);
  const [error, setError]         = useState("");

  const handleRequest = async () => {
    setLoading(true);
    setError("");

    try {
      // Get current vendor info to include in the email
      const { data: { user } } = await supabase.auth.getUser();

      const { data: vendor } = await supabase
        .from("vendors")
        .select("brand_name, email")
        .eq("user_id", user.id)
        .single();

      const res = await fetch("/api/send-email", {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify({
    to: "support@bizbazevents.com",
    cc: ["info@bizbazevents.com"],
    subject: `Reactivation Request — ${vendor?.brand_name || "Vendor"}`,
    html: `
      <div style="font-family: Arial, sans-serif; line-height: 1.6;">
        <h2>Reactivation Request</h2>
        <p>A vendor has requested account reactivation.</p>

        <table style="border-collapse: collapse; width: 100%;">
          <tr>
            <td style="padding: 8px; border: 1px solid #e5e7eb; font-weight: bold;">Brand</td>
            <td style="padding: 8px; border: 1px solid #e5e7eb;">
              ${vendor?.brand_name || "Unknown"}
            </td>
          </tr>
          <tr>
            <td style="padding: 8px; border: 1px solid #e5e7eb; font-weight: bold;">Email</td>
            <td style="padding: 8px; border: 1px solid #e5e7eb;">
              ${vendor?.email || user?.email || "Unknown"}
            </td>
          </tr>
        </table>

        <p style="margin-top: 16px;">
          Log in to the admin panel to review and reactivate this account.
        </p>
      </div>
    `,
  }),
});

      if (!res.ok) throw new Error("Failed to send request");
      setRequested(true);
    } catch (err) {
      setError("Something went wrong. Please email us directly at support@bizbazevents.com");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="hold-page">
      <div className="hold-card">

        <div className="hold-icon">⏸</div>

        <h1 className="hold-title">Account On Hold</h1>

        <p className="hold-body">
          Your account has been temporarily suspended. This may be due to a missed
          payment deadline or a pending review by our team.
        </p>

        <p className="hold-body">
          If you believe this is a mistake or you're ready to continue, request
          reactivation below and our team will get back to you shortly.
        </p>

        {error && (
          <div className="hold-error">{error}</div>
        )}

        {requested ? (
          <div className="hold-success">
            <span>✓</span>
            Request sent! We'll be in touch at the email on your account.
          </div>
        ) : (
          <button
            className="hold-btn"
            onClick={handleRequest}
            disabled={loading}
          >
            {loading ? "Sending request…" : "Request Reactivation"}
          </button>
        )}

        <p className="hold-footer">
          Questions? Email us at{" "}
          <a href="mailto:support@bizbazevents.com">support@bizbazevents.com</a>
        </p>

      </div>
    </div>
  );
}